import React from 'react';
import { createRoot } from 'react-dom/client';
import providerHOC from 'app/utils/providerHOC/providerHOC';
import productDetailsHOC from './productDetailsHOC';
import ProductDetailsApp from './productDetailsContainer';
import store from './productDetailsStore';

const ProductDetailsRoot = providerHOC(store)(productDetailsHOC(ProductDetailsApp));

createRoot(document.getElementById('pdpDetails')).render(<ProductDetailsRoot />);
